import { gql } from '@apollo/client';

export const GET_ACTIVE_CLIENTS = gql`
  query getActiveClientList($input: GetActiveClientListInput!, $first: Int) {
    getActiveClientList(input: $input, first: $first) {
      nickname
      payments
      total_seconds
      last_client_activity
      avatar_url
      roles {
        alias
      }
    }
  }
`;

export const GET_START_WORKSHIFT = gql`
  query activeWorkShift {
    activeWorkShift {
      created_at
    }
  }
`;
